<template>
  <nav class="ren-decoration-cp ren-decoration-cp-cms-tabs">
    <span v-for="(item, index) in tabs" :key="index" :class="{ 'is-active': item.value === defaultTab }">
      {{ item.label }}
    </span>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { recordList, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const defaultTab = computed(() => stringValue(props.component.props?.defaultTab))
const tabs = computed(() =>
  recordList(props.component.props?.tabs).map((item) => ({
    label: stringValue(item.label, '标签'),
    value: stringValue(item.value)
  }))
)
</script>

<style scoped>
.ren-decoration-cp-cms-tabs {
  display: flex;
  gap: 12px;
}
.ren-decoration-cp-cms-tabs span {
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-cms-tabs .is-active {
  color: var(--ren-theme-primary);
  border-bottom-color: var(--ren-theme-primary);
}
</style>
